const states = {};

states.INCOMPLETE = 9900;
states[9900] = 'INCOMPLETE';

states.UNALLOCATED = 10000;
states[10000] = 'UNALLOCATED';

states.PENDING = 10100;
states[10100] = 'PENDING';

states.ALLOCATED = 10200;
states[10200] = 'ALLOCATED';

states.AWAITING_PICKUP = 10300;
states[10300] = 'AWAITING_PICKUP';

states.BEING_COLLECTED = 10400;
states[10400] = 'BEING_COLLECTED';

states.TRANSPORT_TO_GARAGE = 10500;
states[10500] = 'TRANSPORT_TO_GARAGE';

states.AT_GARAGE = 10600;
states[10600] = 'AT_GARAGE';

states.WORK_COMPLETE = 10700;
states[10700] = 'WORK_COMPLETE';

states.PAID = 10800;
states[10800] = 'PAID';

states.BEING_RETURNED = 10900;
states[10900] = 'BEING_RETURNED';

states.CLOSED = 11000;
states[11000] = 'CLOSED';

states.CANCELLED = 20000;
states[20000] = 'CANCELLED';

states.GARAGE_DECLINED = 20100;
states[20100] = 'GARAGE_DECLINED';

states.BOOKING_CHANGE = 20200;
states[20200] = 'BOOKING_CHANGE';

states.UNPAID = 20300;
states[20300] = 'UNPAID';

states.DISPUTE = 20400;
states[20400] = 'DISPUTE';

export default states;
